import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'
import Cookies from 'universal-cookie'

const HomeIntroBg = require('../images/intro-bg.jpg') as string

const cookies = new Cookies()

const IntroWrap = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: flex-start;
    justify-content: center;
    background-image: url(${HomeIntroBg});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    z-index: 100;
`

const IntroContainer = styled(motion.div)`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    z-index: 10000;
    will-change: opacity;
`

const IntroAnimation = styled(motion.div)`
    will-change: transform;
    padding-top: 146px;

    ${media('<desktop')} {
        text-align: center;
        svg {
            width: 90%;
            height: 100%;
            margin: 0 auto;
        }
    }
`

const IntroSubtitle = styled.ul`
    display: flex;
    justify-content: center;
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: ${Variables.color.pazola};
    margin-top: 27px;
    padding: 0;

    li {
        padding-right: 15px;
        list-style: none;
        display: flex;
        align-items: center;
        &::after {
            content: '';
            width: 6px;
            height: 6px;
            background-color: ${Variables.color.pazola};
            margin-left: 15px;
            border-radius: 5px;
            display: inline-block;
        }
        &:last-child {
            padding-right: 0;
            &::after {
                display: none;
            }
        }
    }

    ${media('<desktop')} {
        font-size: 16px;
        line-height: 20px;
    }
`

const HomeIntro = () => {
    useEffect(() => {
        setTimeout(() => {
            cookies.set('home-intro-loaded', 'yes')
        }, 200)
    }, [])

    return (
        <>
            <IntroContainer
                animate={{
                    opacity: 0,
                    transitionEnd: { display: 'none' },
                }}
                transition={{
                    delay: 2,
                    duration: 1,
                    type: 'tween',
                }}
            >
                <IntroWrap>
                    <IntroAnimation
                        initial={{ opacity: 0 }}
                        animate={{
                            opacity: 1,
                        }}
                        transition={{
                            type: 'spring',
                            stiffness: 20,
                        }}
                    >
                        <>
                            <svg
                                width="907"
                                height="182"
                                viewBox="0 0 907 182"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_1048_9722)">
                                    <path
                                        d="M64.4281 176.155V178.676H0V176.155C8.2993 174.647 10.5671 170.871 10.5671 155.262V25.9232C10.5671 10.3138 8.2993 6.53811 0 5.03024V2.52115H70.4596C110.472 2.52115 134.888 27.1898 134.888 61.4124C134.888 95.6349 110.472 120.05 70.4596 120.05H49.072V155.286C49.072 170.884 52.5944 174.165 64.4281 176.179V176.155ZM49.072 32.968V89.5914H69.2051C86.8169 89.5914 96.1295 77.5164 96.1295 61.4003C96.1295 45.2843 86.8169 32.968 69.2051 32.968H49.072Z"
                                        fill="#14323C"
                                    />
                                    <path
                                        d="M293.31 176.155V178.676H234.926V176.155C241.97 174.647 244.492 171.378 239.703 153.513L235.927 140.425H178.302L174.78 153.513C169.75 171.378 172.512 174.647 179.557 176.155V178.676H121.172V176.155C126.962 174.394 130.485 170.112 135.515 153.513L180.823 2.52115H233.418L278.714 153.513C283.744 169.87 287.52 174.153 293.31 176.155ZM186.855 109.966H227.374L216.047 69.193C212.525 56.358 209.75 43.5231 207.241 30.1815C204.72 43.5231 201.704 56.358 198.182 69.193L186.855 109.966Z"
                                        fill="#14323C"
                                    />
                                    <path
                                        d="M301.465 178.664L359.295 70.9783C368.86 53.1372 374.506 42.6063 381.587 33.2334H327.931C312.334 33.2334 308.051 34.9946 306.797 41.2794H304.288V2.53322H436.123L378.366 110.219C368.8 128.06 363.155 138.591 356.074 147.964H409.211C424.808 147.964 429.091 146.203 430.092 139.906H432.613V178.652H301.477L301.465 178.664Z"
                                        fill="#14323C"
                                    />
                                    <path
                                        d="M440.707 90.5926C440.707 38.2516 470.249 0 526.366 0C582.483 0 612.037 38.2516 612.037 90.5926C612.037 142.934 582.495 181.185 526.366 181.185C470.237 181.185 440.695 142.934 440.695 90.5926H440.707ZM572.784 90.5926C572.784 57.6246 558.586 32.968 526.378 32.968C494.17 32.968 479.972 57.3834 479.972 90.5926C479.972 123.802 494.17 148.217 526.378 148.217C558.586 148.217 572.784 123.802 572.784 90.5926Z"
                                        fill="#14323C"
                                    />
                                    <path
                                        d="M726.937 178.676H623.509V176.155C631.808 174.647 634.076 170.871 634.076 155.262V25.9232C634.076 10.3259 631.808 6.55017 623.509 5.03024V2.52115H683.148V5.0423C675.09 6.55017 672.581 10.3259 672.581 25.9353V147.976H703.534C719.132 147.976 723.414 146.215 724.427 139.918H726.949V178.676H726.937Z"
                                        fill="#14323C"
                                    />
                                    <path
                                        d="M907 176.155V178.676H848.615V176.155C855.66 174.647 858.181 171.378 853.392 153.513L849.617 140.425H791.992L788.47 153.513C783.439 171.378 786.202 174.647 793.247 176.155V178.676H734.862V176.155C740.652 174.394 744.175 170.112 749.205 153.513L794.501 2.52115H847.096L892.392 153.513C897.422 169.87 901.198 174.153 906.988 176.155H907ZM800.545 109.966H841.064L829.737 69.193C826.215 56.358 823.44 43.5231 820.931 30.1815C818.41 43.5231 815.394 56.358 811.872 69.193L800.545 109.966Z"
                                        fill="#14323C"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1048_9722">
                                        <rect width="907" height="181.197" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <IntroSubtitle>
                                <li>ANDERMATT</li>
                                <li>1444M</li>
                                <li>SWITZERLAND</li>
                            </IntroSubtitle>
                        </>
                    </IntroAnimation>
                </IntroWrap>
            </IntroContainer>
        </>
    )
}

export default HomeIntro
